import React from 'react';

import { useChainId } from '@occc-app/Chain/hooks';

import { InAudience } from './InAudience';
import { useGetAudiencesByIds } from './hooks';

interface IInAudienceContainerProps {
  audienceIds: string[];
}

export const InAudienceContainer: React.FC<IInAudienceContainerProps> = (props) => {
  const chainId = useChainId();
  const { loading, error, data: audiences } = useGetAudiencesByIds(props.audienceIds, chainId);

  return <InAudience loading={loading} audiences={audiences} error={error} />;
};
